(function () {
  // 1) Déclare tes 4 blocs ici : NOM => SELECTEUR CSS (id ou classe)
  // Exemples : '#module-upsell', '.reco-widget', etc.
  const CROSS_SELL_BLOCKS = [
    { name: 'productsheet_boughttogether', selector: '#ga-product_bought_together' },
    { name: 'productsheet_sameauthor', selector: '#moteur_bh_recommandation_same_autor' },
    { name: 'productsheet_samecategory', selector: '#ga-product_related' },
    { name: 'cart_crosssell', selector: '#wigget_26746' },
    
  ];

  // 2) Sélecteurs courants de boutons / formulaires "Ajouter au panier"
  const ADD_TO_CART_SELECTORS = [
    'button[name="add"]',
    'button[type="submit"][name="add"]',
    'form[action*="/cart/add"] button[type="submit"]',
    '[data-add-to-cart]',
    'button.add-to-cart',
    'input[type="submit"][value*="Ajouter"]',
    'button.ga-product_addtocart',
    'button.ga-addalltocart'
  ];

  function closestAddToCart(el) {
    try {
      return el.closest(ADD_TO_CART_SELECTORS.join(','));
    } catch (e) {
      return null;
    }
  }

  function detectBlock(el) {
    for (const b of CROSS_SELL_BLOCKS) {
      try {
        if (el.closest(b.selector)) return b.name;
      } catch (e) {
        // selector invalide => ignore
      }
    }
    return null;
  }

  function gtagEvent(blockName) {
    if (typeof window.gtag !== 'function') return;
    console.log("Cross sell détecté :", blockName);
    window.gtag('event', 'cross_sell_add_click', {
      cross_sell_block: blockName
    });
  }

// Sélecteurs possibles où ton module affiche le prix (à compléter si besoin)
const PRICE_SELECTORS = [
  '.money',
  '.price',
  '[data-price]',
  '.product-price',
  '.price-item',
  '.price__regular',
  '.price__sale'
];

function parsePriceToNumber(text) {
  if (!text) return null;

  // Nettoie et extrait le 1er nombre style "3,90", "3.90", "1 234,56"
  const cleaned = String(text)
    .replace(/\u00A0/g, ' ')           // espaces insécables
    .replace(/[^\d,.\s]/g, ' ')        // garde chiffres + séparateurs
    .trim();

  const m = cleaned.match(/(\d{1,3}(?:[ .]\d{3})*(?:[.,]\d+)?|\d+(?:[.,]\d+)?)/);
  if (!m) return null;

  let n = m[1].replace(/ /g, '').replace(/\./g, '').replace(',', '.');
  const val = Number(n);
  return Number.isFinite(val) ? val : null;
}

function findPriceNearButton(btn) {
  // Essaye d’abord de trouver un conteneur “produit” autour du bouton
  const card =
    btn.closest('.product, .product-card, .grid__item, .upsell-item, .reco-item, li, article, .ga-product') ||
    btn.parentElement;

  if (!card) return null;

  // 1) data-price prioritaire
  for (const sel of PRICE_SELECTORS) {
    const el = card.querySelector(sel);
    if (!el) continue;
    const dataPrice = el.getAttribute('data-price');
    const price = parsePriceToNumber(dataPrice || el.textContent);
    if (price != null) return price;
  }

  return null;
}


function sendCrossSell(blockName, btn) {
  if (typeof window.gtag !== 'function') return;

  const price = btn ? findPriceNearButton(btn) : null;

  window.gtag('event', 'cross_sell_add_click', {
    cross_sell_block: blockName,
    currency: 'EUR',
    // value doit être un nombre. Si on ne trouve pas le prix, on n’envoie pas value.
    value: price != null ? price : undefined,
    transport_type: 'beacon'
  });

  console.log("Cross sell détecté :", blockName, "price:", price);
}

document.addEventListener('pointerdown', function (e) {
  const btn = e.target.closest(ADD_TO_CART_SELECTORS.join(','));
  if (!btn) return;

  const blockName = detectBlock(btn);
  if (!blockName) return;

  sendCrossSell(blockName, btn);
}, true);

})();